
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconViewColumn = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M6.5 0h-6a.5.5 0 0 0-.5.5v22a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5zM14.5 0h-6a.5.5 0 0 0-.5.5v22a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5zM22.5 0h-6a.5.5 0 0 0-.5.5v22a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5z' }),
    React.createElement(
      'g',
      null,
      React.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' })
    )
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M6.5 0h-6a.5.5 0 0 0-.5.5v22a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5zM14.5 0h-6a.5.5 0 0 0-.5.5v22a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5zM22.5 0h-6a.5.5 0 0 0-.5.5v22a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5z' }),
    React.createElement(
      'g',
      null,
      React.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' })
    )
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M6.5 0h-6a.5.5 0 0 0-.5.5v22a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5zM14.5 0h-6a.5.5 0 0 0-.5.5v22a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5zM22.5 0h-6a.5.5 0 0 0-.5.5v22a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5z' }),
    React.createElement(
      'g',
      null,
      React.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' })
    )
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconViewColumn.displayName = 'IconViewColumn';
export default IconViewColumn;